import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/img/icons/dashboard/bell-icon.svg';
import _imports_1 from '@/assets/img/theme/btn-loader-black.svg';
import _imports_2 from '@/assets/img/icons/menu/upgrade-icon.svg';
const _hoisted_1 = {
  key: 0,
  class: "upgrade-banner"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "upgrade-banner-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Bell",
  width: "24"
})], -1);
const _hoisted_3 = {
  class: "font-15 fw-500 text-900"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-upgrade ml-2"
}, " Ready to activate", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "font-13 text-700 mb-0 mt-1"
}, " Your premium features are waiting to be unlocked. ", -1);
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "load",
  class: "d-inline-block",
  width: "75"
}, null, -1);
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "upgrade",
  width: "16",
  class: "me-1"
}, null, -1);
import { computed, onMounted, watch, ref } from "vue";
import { useRouter } from "vue-router";
import { usePayment } from "@/store/payment";
import { setLastSelectedPlan } from "@/api/payment";
export default {
  __name: 'PlanUpgradeBanner',
  setup(__props) {
    const paymentStore = usePayment();
    const router = useRouter();
    const newPlanDetails = computed(() => paymentStore.planDetails);
    const planDetailsUpdated = computed(() => paymentStore.planLoaded);
    const clientPlan = computed(() => paymentStore.planDetails);
    const showBanner = computed(() => {
      if (planDetailsUpdated.value) {
        return {
          no_plan: newPlanDetails.value?.planName ? false : true
        };
      } else {
        return {
          no_plan: true
        };
      }
    });
    const apiProcessing = ref(false);
    const goToAccount = () => {
      apiProcessing.value = true;
      setLastSelectedPlan(newPlanDetails.value).then(() => {
        router.push("/payment-method");
      }).catch(error => {
        console.log(error);
        apiProcessing.value = false;
      }).finally(() => {
        apiProcessing.value = false;
      });
    };
    onMounted(() => {
      // Ensure plan details are loaded
      paymentStore.getPlanDetails();
    });
    watch(clientPlan, data => {
      if (data.newPlanRequest) {
        paymentStore.planDetails = data.newPlanRequest;
      }
    });
    return (_ctx, _cache) => {
      const _component_b_col = _resolveComponent("b-col");
      const _component_b_button = _resolveComponent("b-button");
      const _component_b_row = _resolveComponent("b-row");
      const _component_b_container = _resolveComponent("b-container");
      return !showBanner.value.no_plan ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_container, {
        fluid: "",
        class: "with-menu"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_row, {
          "align-v": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_col, {
            cols: "auto"
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_b_col, null, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(newPlanDetails.value.planName) + " plan ", 1), _hoisted_4]), _hoisted_5]),
            _: 1
          }), _createVNode(_component_b_col, {
            md: "auto",
            class: "ps-9 ps-md pt-md-0 pt-3"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_button, {
              variant: "outline-dark",
              class: "mc-btn font-13 ms-5 ms-md-0 bg-transparent",
              size: "sm",
              onClick: goToAccount
            }, {
              default: _withCtx(() => [apiProcessing.value ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8)) : (_openBlock(), _createElementBlock("span", _hoisted_9, [_hoisted_10, _createTextVNode(" Activate Now ")]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true);
    };
  }
};